import React from "react";

const UpComming = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>🚧 Coming Soon 🚧</h1>
      <p style={styles.text}>We’re working hard to bring something amazing!</p>
    </div>
  );
};

const styles = {
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#000",
    textAlign: "center",
  },
  title: {
    fontSize: "48px",
    marginBottom: "16px",
    animation: "pulse 1.5s infinite",
  },
  text: {
    fontSize: "20px",
    opacity: 0.9,
  },
};

// Add simple animation
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}
`;
document.head.appendChild(styleSheet);

export default UpComming;
